import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/content/site";

// Plovoucí WhatsApp tlačítko — jemný pulz (wa-pulse) místo agresivního blikání.
// Animace se automaticky vypíná při prefers-reduced-motion (globální pravidlo v index.css).
export const FloatingWhatsApp = () => (
  <a
    href={CONTACT.whatsappHref}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp"
    aria-label="Napsat na WhatsApp"
    className="wa-pulse fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-[#B69A58] text-white border-2 border-white shadow-[0_4px_20px_rgba(0,0,0,0.15)] hover:bg-[#a68d4f] transition-colors duration-300"
  >
    <MessageCircle className="h-6 w-6" strokeWidth={1.5} aria-hidden="true" />
    <span className="sr-only">Napsat na WhatsApp</span>
  </a>
);
